﻿import $ from "jquery";

export class LanguageSelector {
    public init(formId: string): void {
        const form = $(`#${formId}`);
        form.on("change", () => {
            let redirectUrlField = form.find("[name='redirectUrl']");
            redirectUrlField.val((window as any).location);
            form.trigger("submit");
        });
    }
}